import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useEffect, useState } from 'react';
import { Box, DialogContent, DialogContentText, TextField } from '@mui/material';
import { nanoid } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';
import { InfoDial } from 'ui/InfoDial';
import { Notice } from 'ui/Notice';
import { TEditSkuDialogProps } from './types';

export const EditSkuDialog: FC<TEditSkuDialogProps> = ({ open, setClose, handleEdit, skuText }) => {
	const [sku, setSku] = useState<string>(skuText);
	useEffect(() => {
		setSku(skuText);
	}, [skuText]);
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary">Edit SKU</DialogTitle>
			<DialogContent
				sx={{
					p: '0 12px 0px 12px',
				}}
			>
				{/* <Notice
					sx={{
						margin: '0px!important',
					}}
					text="Add the new SKUs you want to add to the system. Each SKU should be on a new line."
				/> */}
				<TextField
					sx={{
						mt: '12px',
						'& .MuiInputBase-root': {
							padding: '6px 8px',
							lineHeight: '1.5',
							borderRadius: '12px',
							// fontSize: '0.9rem',
						},
					}}
					autoFocus
					label="SKU"
					value={sku}
					onChange={(e) => setSku(e.target.value)}
					type="text"
					fullWidth
				/>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={setClose}
					sx={{
						textTransform: 'none',
					}}
				>
					Cancel
				</Button>
				<Button
					onClick={() => handleEdit(sku)}
					autoFocus
					sx={{
						textTransform: 'none',
					}}
				>
					Send
				</Button>
			</DialogActions>
		</Dialog>
	);
};
